var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.getSign
    ? _c("div", { staticClass: "product-information__mobile--wrapper" }, [
        _c("div", { staticClass: "product-information" }, [
          _vm.languageStrings.delivery_times
            ? _c("div", [
                _c("div", { staticClass: "icon icon-delivery" }),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.languageStrings.delivery_times))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.languageStrings.shipping_cost
            ? _c("div", [
                _c("div", { staticClass: "icon icon-box" }),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.languageStrings.shipping_cost))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.trustIcons
            ? _c(
                "div",
                { staticClass: "service-logos" },
                [
                  _c("div", { staticClass: "icon icon-credit-card" }),
                  _vm._v(" "),
                  _vm._l(_vm.trustIcons[0], function (iconItem, index) {
                    return _c("div", { key: index }, [
                      _c(
                        "div",
                        { staticClass: "service-logo", class: iconItem.class },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(_vm._s(iconItem.class)),
                          ]),
                        ]
                      ),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "icon icon-information" }),
            _vm._v(" "),
            _vm.languageStrings.terms && _vm.settings.termspage
              ? _c("div", [
                  _c("a", { attrs: { href: _vm.settings.termspage } }, [
                    _vm._v(_vm._s(_vm.languageStrings.terms)),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "accordion",
            class: _vm.description && "accordion__open",
          },
          [
            _c(
              "button",
              {
                staticClass: "accordion__button",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.description = !_vm.description
                  },
                },
              },
              [_vm._v("\n      Produktinformation\n    ")]
            ),
            _vm._v(" "),
            _vm.description
              ? _c("div", { staticClass: "accordion__panel" }, [
                  _c(
                    "div",
                    {
                      staticClass: "product-description base-information",
                      class: `${
                        _vm.checkDescriptionLength()
                          ? ""
                          : _vm.descriptionFold
                          ? "product-description-folded"
                          : ""
                      }`,
                    },
                    [
                      _vm.descriptionFold && !_vm.checkDescriptionLength()
                        ? _c(
                            "button",
                            {
                              staticClass: "button button-toggle-description",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.descriptionFold = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.languageStrings.show_product_information
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getSign.description
                        ? _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.parseSignDescription),
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "accordion",
            class: _vm.specification && "accordion__open",
          },
          [
            _c(
              "button",
              {
                staticClass: "accordion__button",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.specification = !_vm.specification
                  },
                },
              },
              [_vm._v("\n      Specifikationer\n    ")]
            ),
            _vm._v(" "),
            _vm.specification
              ? _c(
                  "div",
                  { staticClass: "accordion__panel accordion__panel--white" },
                  [
                    _c("div", [
                      _vm.languageStrings.material
                        ? _c("div", [
                            _c("div", { staticClass: "is-size-7" }, [
                              _vm._v(
                                _vm._s(_vm.languageStrings.material_title)
                              ),
                            ]),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.languageStrings.color) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "is-size-7" }, [
                          _vm._v(_vm._s(_vm.languageStrings.size)),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getSign.width) +
                            " x " +
                            _vm._s(_vm.getSign.height) +
                            " mm\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.languageStrings.color
                        ? _c("div", [
                            _c("div", { staticClass: "is-size-7" }, [
                              _vm._v(_vm._s(_vm.languageStrings.variant)),
                            ]),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.languageStrings.material) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getSign.interfaces
                        ? _c("div", [
                            _vm.languageStrings.interface_application
                              ? _c("div", { staticClass: "is-size-7" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.languageStrings
                                          .interface_application
                                      ) +
                                      "\n          "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(
                                _vm.getInterfaces(),
                                function (interfaceItem, index) {
                                  return _c(
                                    "li",
                                    { key: index },
                                    [
                                      interfaceItem === "sign_interface_tape" &&
                                      _vm.languageStrings.sign_interface_tape
                                        ? [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.languageStrings
                                                    .sign_interface_tape
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      interfaceItem ===
                                        "sign_interface_militaryclip" &&
                                      _vm.languageStrings
                                        .sign_interface_militaryclip
                                        ? [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.languageStrings
                                                    .sign_interface_militaryclip
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      interfaceItem ===
                                        "sign_interface_screw" &&
                                      _vm.languageStrings.sign_interface_screws
                                        ? [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.languageStrings
                                                    .sign_interface_screws
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      interfaceItem ===
                                        "sign_interface_safetypin" &&
                                      _vm.languageStrings
                                        .sign_interface_safetypin
                                        ? [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.languageStrings
                                                    .sign_interface_safetypin
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      interfaceItem ===
                                        "sign_interface_metalmagnet" &&
                                      _vm.languageStrings
                                        .sign_interface_metalmagnet
                                        ? [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.languageStrings
                                                    .sign_interface_metalmagnet
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      interfaceItem ===
                                        "sign_interface_plasticmagnet" &&
                                      _vm.languageStrings
                                        .sign_interface_plasticmagnet
                                        ? [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.languageStrings
                                                    .sign_interface_plasticmagnet
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      interfaceItem ===
                                        "sign_interface_keyring" &&
                                      _vm.languageStrings.sign_interface_keyring
                                        ? [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.languageStrings
                                                    .sign_interface_keyring
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.languageStrings.tape_included &&
                      _vm.getSign.hasholes !== "1"
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "product-promises-item tape-included",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.languageStrings.tape_included) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "product-promises-item screws-included",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.languageStrings.screws_included) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.languageStrings.large_orders
                        ? _c("div", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.languageStrings.large_orders) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.languageStrings.sku && _vm.getSign.sku
                        ? _c("div", [
                            _c("span", { staticClass: "is-size-7" }, [
                              _vm._v(
                                _vm._s(_vm.languageStrings.sku) +
                                  " " +
                                  _vm._s(_vm.getSign.sku)
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getSign.saleprice !== "0"
                        ? _c("div", [
                            _vm.getSign.saleprice
                              ? _c("div", { staticClass: "is-size-4" }, [
                                  _c("span", { staticClass: "is-size-7" }, [
                                    _vm._v(
                                      _vm._s(_vm.languageStrings.base_price) +
                                        "  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c(
                                      "span",
                                      { staticClass: "price__original" },
                                      [_vm._v(_vm._s(_vm.getSign.price))]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.getSign.saleprice)),
                                    ]),
                                    _vm._v(" "),
                                    _vm.languageStrings.currency_symbol
                                      ? _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.languageStrings
                                                .currency_symbol
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getSign.saleprice
                              ? _c("div", { staticClass: "is-size-7" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.calculateVat(_vm.getSign.saleprice)
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.languageStrings.ex_vat
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.languageStrings.ex_vat)
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ])
                        : _c("div", [
                            _vm.getSign.price
                              ? _c("div", { staticClass: "is-size-4" }, [
                                  _c("span", { staticClass: "is-size-7" }, [
                                    _vm._v(
                                      _vm._s(_vm.languageStrings.base_price) +
                                        "  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.getSign.price)),
                                    ]),
                                    _vm._v(" "),
                                    _vm.languageStrings.currency_symbol
                                      ? _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.languageStrings
                                                .currency_symbol
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getSign.price
                              ? _c("div", { staticClass: "is-size-7" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.calculateVat(_vm.getSign.price)
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.languageStrings.ex_vat
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.languageStrings.ex_vat)
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.languageStrings.reservation
          ? _c("div", { staticClass: "reserved-for-typos" }, [
              _c("div", { staticClass: "is-size-7" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.languageStrings.reservation) +
                    "\n    "
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }